import React from 'react';
import { FolderSimple, Files, Lightning, Clock } from '@phosphor-icons/react'

const StatCard = ({ icon: Icon, title, value }) => (
  <div className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow">
    <div className="flex items-center gap-4">
      <div className="bg-blue-100 p-3 rounded-full">
        <Icon className="w-6 h-6 text-blue-600" />
      </div>
      <div className="flex flex-col">
        <span className="text-sm text-gray-600">{title}</span>
        <span className="text-2xl font-semibold text-gray-900">{value}</span>
      </div>
    </div>
  </div>
);

const UserStats = ({ 
  total_projects = 0, 
  total_documents = 0, 
  total_actions_used = 0, 
  max_actions_per_month = 0 
}) => {
  const stats = [
    {
      icon: FolderSimple,
      title: "Total Projects",
      value: total_projects,
    },
    {
      icon: Files,
      title: "Total Documents",
      value: total_documents,
    },
    {
      icon: Lightning,
      title: "Total Actions Used",
      value: total_actions_used,
    },
    {
      icon: Clock,
      title: "Max Actions Per Month",
      value: max_actions_per_month,
    },
  ];

  return (
    <div className="p-6 bg-gray-50 rounded-xl">
      <h2 className="text-xl font-semibold text-gray-800 mb-6">Usage Statistics</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((stat, index) => (
          <StatCard
            key={index}
            icon={stat.icon}
            title={stat.title}
            value={stat.value}
          />
        ))}
      </div>
    </div>
  );
};

export default UserStats;